

































































import Vue from 'vue';
import moment from 'moment';

import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';

import miscService from '@/services/MiscService';

export default Vue.extend<any, any, any, any>({
  mixins: [breakpointsMixin, iconsMixin],
  data() {
    return {
      snackbarText: null,
      snackbar: false,
    };
  },
  methods: {
    back() {
      window.location.href = '/customer/spot-market';
    },
    /* istanbul ignore next */
    copyToClipboard() {
      navigator.clipboard.writeText(this.shipmentId);
      this.snackbarText = `Shipment # ${this.shipmentId} has been copied to the clipboard`;
      this.snackbar = true;
    },
    rateConfirmation() {
      window
        .open(
          `/customer/shipment/${this.shipmentId}/rate-confirmation`,
          '_blank'
        )
        .focus();
    },
    /* istanbul ignore next */
    openBillOfLadingPdf() {
      window
        .open(`/customer/shipment/${this.shipmentId}/bol`, '_blank')
        .focus();
    },
  },
  computed: {
    shipmentId() {
      return this.$route.params.shipmentId;
    },
    bidId() {
      return this.$route.params.bidId;
    },
    date() {
      return moment().format('MMMM DD, YYYY');
    },
  },
});
